export default [
    ['C', '创建'],
    ['R', '读取'],
    ['U', '更新'],
    ['D', '删除'],
]
